<script>
	import { onMount } from 'svelte';
    import model from '../../stores/modelStore';
    import newRegModel from '../../stores/registrationStore';
	import textStore from "../../stores/textStore";
	import { projectSettings, referralTypes, genderOptions, contactMethodOptions } from "../../config";
	import registrationTypes from "../../config/registrationTypes";
	import Person from "../../models/Person";
	import ClaimantDetails from "../../models/ClaimantDetails";
	import { isValid } from "../../validation";
	import { registerPageComplete } from "../../tealium";

	import Contact from "../../components/Contact.svelte";
	import Form from "../../components/Form.svelte";
	import FormRow from "../../components/FormRow.svelte";
	import FormColumn from "../../components/FormColumn.svelte";
	import Select from "../../components/Select.svelte";
	import Claimant from "../../components/Claimant.svelte";
	import PageSection from "../../components/PageSection.svelte";
	import NavigationButtons from "../../components/NavigationButtons.svelte";
	import ClassActionPhoneNumber from "../../components/ClassActionPhoneNumber.svelte";
    import ClassActionEmailAddress from "../../components/ClassActionEmailAddress.svelte";
	import YesNoGroup from "../../components/YesNoGroup.svelte";
    import RadioGroup from '../../components/RadioGroup.svelte';
    import TextArea from '../../components/TextArea.svelte';
    import TextInput from '../../components/TextInput.svelte';
    import PhoneInput from '../../components/PhoneInput.svelte';
    import EmailInput from '../../components/EmailInput.svelte';

	export let disabled = null;
	export let pageName = null;
	export let pageTitle = null;
	export let persistUrl = null;
	export let lastVisitedPage = null;

	let required = true;
	let requiredSomeOneEmail = true;
	let requiredSomeOnePhone = true;
	let buttons = null;


	export const whosDoingFormOptions = [
		{ label: "Yourself", value: registrationTypes.types.Myself.value },
		{ label: "Helping someone else", value: registrationTypes.types.SomeoneElse.value },
	];


	if (!disabled) {
		$model.lastPageVisited = lastVisitedPage;
		document.title = pageTitle;
	}

	const preSubmit = () => {
		if ($model.contactedThrough !== "Through a support person"){
			$model.contact = {...$model.claimant};
		}

		if ($model.registrationType !== registrationTypes.types.SomeoneElse.value){
			$model.entrant = null;
		}
	}

    const handleSubmit = async (e) => {
    	buttons.blockNext();

		let errors = isValid();

		if (!errors.length) {
			preSubmit();

			let response = await model.saveModelAsync(persistUrl);

			if (!response.success) {
				console.log(response);
			} else {
				registerPageComplete(
					pageName,
					$model.contact.emailAddress,
					$model.contact.phoneNumber,
				);
				buttons.next();
			}
		} else {
			errors[0].scrollIntoView({ behavior: "smooth" });
		}

		buttons.unblock();
    };

	const handleRegistrationTypeChange = () => {
		$model.claimants = [ new Person() ];
		$model.claimantDetails = new ClaimantDetails();
	};

	const handleContactWhoChange = (e) => {
		//if (e.target.value === "Through a support person"){
		//	$model.contact = new Person();
		//}
	};

	const handleWhosDoingChange = (e) => {
		//console.log("handleWhosDoingChange", e.target.value, (e.target.value === registrationTypes.types.SomeoneElse.value), $model);

		if (e.target.value === registrationTypes.types.SomeoneElse.value){
			$model.entrant = new Person();
		}
	}

	const rePopulate = () => {
		if ($newRegModel){
			console.log("model1");
			$newRegModel.contact={...$model.contact};
			$newRegModel.claimant={...$model.claimant};
			$newRegModel.entrant={...$model.entrant};

			$newRegModel.registrationType = $model.registrationType;
			$newRegModel.knownHow = $model.knownHow;
			$newRegModel.claimantHasOtherNames = $model.claimantHasOtherNames;
			$newRegModel.postalAddressIsDifferent = $model.postalAddressIsDifferent;
			$newRegModel.claimantPlaceOfBirth = $model.claimantPlaceOfBirth;
			$newRegModel.gender = $model.gender;
			$newRegModel.firstNation = $model.firstNation;
			$newRegModel.contactedThrough = $model.contactedThrough;
			$newRegModel.relationshipToClaimant = $model.relationshipToClaimant;
			$newRegModel.language = $model.language;
			$newRegModel.community = $model.community;
			$newRegModel.claimantDateOfBirth = $model.claimantDateOfBirth;

			if ($model.parentRegistrationNumber){
				$newRegModel.parentRegistrationNumber = $model.parentRegistrationNumber;
			}else{
				$newRegModel.parentRegistrationNumber = $model.registrationNumber;
			}
			
			$newRegModel.privacyPolicyConfirmed = true;

			model.setModel($newRegModel);

			console.log(`Next Registration - ${$newRegModel.registrationNumber} - `, $newRegModel.parentRegistrationNumber);
		}
	}

	onMount(async () => {
		console.log("Next Registration Mount");
		await newRegModel.getModelAsync();
		rePopulate();
	});

	const initialise = () => {
		console.log("Next Registration Init");

		if (!$model.entrant){
			$model.entrant = new Person();	// must always have entrant due to timing from handleWhosDoingChange & reactivity 
		}
	};

	initialise();
	
	$: {
		textStore.switchText($model.registrationType);

		if ($model.registrationType === registrationTypes.types.SomeoneElse.value){
			if ($model.entrant && $model.entrant.emailAddress){
				requiredSomeOnePhone = false;
			}else{
				requiredSomeOnePhone = true;
			}

			if ($model.entrant && $model.entrant.phoneNumber){
				requiredSomeOneEmail = false;
			}else{
				requiredSomeOneEmail = false;
			}
		}

	}

</script>

<PageSection>
	<Form {disabled} id="form-personal-details" on:submit={handleSubmit}>
		<FormRow class="justify-content-center confirmation-hide">
			<FormColumn>
				<h4 class="text-center">{@html projectSettings.classActionName}</h4>
				<h1 class="text-center">Please provide your details</h1>
			</FormColumn>
		</FormRow>
	

		<div class="confirmation-box-shadow">
			<FormRow>
				<FormColumn>
					<RadioGroup
						{disabled}
						{required}
						name="whosDoingForm"
						label="Are you completing this form for yourself or are you helping someone else?"
						optionList={whosDoingFormOptions}
						bind:value={$model.registrationType}
						on:change={handleWhosDoingChange}>
					</RadioGroup>
				</FormColumn>
			</FormRow>

			{#if $model.registrationType && $model.registrationType != registrationTypes.types.Myself.value}
				<FormRow>
					<FormColumn>
						<p>You are allowed to have help filling out this form. 
						If someone is helping you, that person needs to give us their details below.
						</p>
					</FormColumn>
				</FormRow>
				<FormRow>
					<FormColumn cols="12">
						<TextArea
							{required}
							{disabled}
							id="knowHow"
							name=""
							label="If you are filling out this form for the claimant, how do you know him or her?"
							bind:value={$model.knownHow}
							maxlength=8000
							rows=2
						>
						</TextArea>
					</FormColumn>
				</FormRow>

				<FormRow>
					<FormColumn cols="6">
						<TextInput label="Your first name" {required} {disabled} bind:value="{$model.entrant.firstName}" id="entrant_firstName" />
					</FormColumn>
					<FormColumn cols="6">
						<TextInput label="Your last name" {required} {disabled} bind:value="{$model.entrant.surname}" id="entrant_surname" />
					</FormColumn>
				</FormRow>

				<FormRow>
					<FormColumn cols="6">
						<EmailInput label="Your email address" required={requiredSomeOneEmail} {disabled} bind:value="{$model.entrant.emailAddress}" id="entrant_email" />
					</FormColumn>
					<FormColumn cols="6">
						<PhoneInput label="Your phone number" required={requiredSomeOnePhone} {disabled} bind:value="{$model.entrant.phoneNumber}" id="entrant_phone" />
					</FormColumn>
				</FormRow>
				<FormRow>
					<FormColumn>
						<p>
						In the rest of the form, when we ask about "you", we are asking about the person who is being registered.
						</p>
					</FormColumn>
				</FormRow>
			{/if}

		</div>

		<FormRow>
			<FormColumn>
				<div class="claimant-details">
					<FormRow>
						<FormColumn>
							<h2>Claimant Details</h2>
						</FormColumn>
					</FormRow>
	
					<hr class="primary" />

					<div class="confirmation-box-shadow">
						<Claimant
							{disabled}
							bind:claimant={$model.claimant}
							bind:hasOtherNames={$model.claimantHasOtherNames}
							bind:postalAddressIsDifferent={$model.postalAddressIsDifferent}
							bind:postalAddress={$model.claimant.postalAddress}
							bind:claimantPlaceOfBirth={$model.claimantPlaceOfBirth}
							bind:claimantDateOfBirth={$model.claimantDateOfBirth}
							required={true}
						/>

						<FormRow>
							<FormColumn>
								 <RadioGroup
									{disabled}
									required={false}
									name="gender"
									label="Your gender"
									bind:value={$model.gender}
									optionList={genderOptions}
									on:change></RadioGroup>
							</FormColumn>
						</FormRow>
						<FormRow>
							<FormColumn>
								 <YesNoGroup
									{disabled}
									required={false}
									name="firstNations"
									label="Are you Aboriginal or Torres Strait Islander?"
									bind:value={$model.firstNation}
									></YesNoGroup>
							</FormColumn>
						</FormRow>

						<FormRow>
							<FormColumn>
								<RadioGroup
									{disabled}
									required={false}
									name="contactedThrough"
									label="How do you want to be contacted?"
									bind:value={$model.contactedThrough}
									optionList={contactMethodOptions}
									on:change={handleContactWhoChange}></RadioGroup>
							</FormColumn>
						</FormRow>

						{#if $model.contactedThrough ==="Through a support person"}
							<FormRow>
								<FormColumn>
									<h2>Support person's details</h2>
								</FormColumn>
							</FormRow>
							<p>
								If you want to be contacted through a support person, what are his or her details:
							</p>
							<hr class="primary" />

							<Contact
								required={false}
								{disabled}
								bind:firstName={$model.contact.firstName}
								bind:surname={$model.contact.surname}
								bind:emailAddress={$model.contact.emailAddress}
								bind:phoneNumber={$model.contact.phoneNumber}
								bind:address={$model.contact.address}
								showDateOfBirth={false}
								showOtherNamesList={false}
								requiredPhoneOrEmail={true}
								requiredFirstNameAndSurname={true}
							/>
							<FormRow>
								<FormColumn>
									<TextInput
										label="Relationship to the claimant"
										bind:value={$model.relationshipToClaimant}
										maxlength=200
										required={false}
										{disabled}
									/>
								</FormColumn>
							</FormRow>
							<hr class="primary" />
						{/if}
						
						<FormRow class="no-margin-top" >
							<!-- svelte-ignore a11y-label-has-associated-control -->
							<label>What language do you or your support person want to talk to us in?</label>
							<FormColumn cols="6">
								<TextInput
									label="Language"
									bind:value={$model.language}
									maxlength=200
									required={false}
									{disabled}
								/>
							</FormColumn>
							<FormColumn>
								<TextInput
									label="Community"
									bind:value={$model.community}
									maxlength=200
									required={false}
									{disabled}
								/>
							</FormColumn>
						</FormRow>
					</div>
				</div>
			</FormColumn>
		</FormRow>


		<FormRow class="justify-content-md-center confirmation-hide">
            <FormColumn class="text-center">
				<NavigationButtons bind:buttons
					nextPageLabel={$model.confirmationPage ? "Confirmation" : "Next"} />
			</FormColumn>
		</FormRow>
	</Form>

</PageSection>

<style>

	.claimant-details {
		margin-bottom: 20px;
	}

	div.no-margin-top{
		margin-top: 0px;
	}
</style>
